import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import { Button, Paper } from "@mui/material";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";

export default function BoxSx({
  criticalContext,
  total_score,
  requestContactExpert,
  uuid,
  removeIt,
  risks,
}) {
  const { t } = useTranslation();
  return (
    <Paper
      sx={{
        p: 2,
        margin: "auto",
        flexGrow: 1,
        backgroundColor: "#F5F7FB",
        minHeight: "220px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={12}>
          <span style={{ fontWeight: "600", fontSize: "20px" }}>
            {t("current_status")}:{" "}
            <span style={{ color: criticalContext.colorCode }}>
              {t(criticalContext.title)}
            </span>
          </span>
        </Grid>
        <Grid item>
          <ButtonBase sx={{ width: 128, height: 128 }}>
            <CircularProgressbar
              styles={{
                path: {
                  // Path color
                  stroke: criticalContext.colorCode,
                },
                text: {
                  // Text color
                  fill: "#000000",
                },
              }}
              maxValue={10}
              value={total_score}
              text={total_score}
            />
          </ButtonBase>
        </Grid>
        <Grid item xs={12} sm container>
          <Grid item xs container direction="column" spacing={2}>
            <Grid item xs>
              <Typography variant="body2" gutterBottom>
                {t(criticalContext.description)}
              </Typography>
            </Grid>
            {/* {!removeIt && (
              <Grid item>
                <Button
                  size="small"
                  onClick={() =>
                    requestContactExpert(
                      `https://app.cytailor.io/consult-report/${uuid}`
                    )
                  }
                  // disabled={data.required}

                  color="secondary"
                  variant="contained"
                  fullWidth
                >
                  {t("cyber_experts")}
                </Button>
              </Grid>
            )} */}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
